import PropTypes from 'prop-types';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

import Carousel from 'nuka-carousel';

import { formatDate } from 'lib';
import { dateFormatStr, dateFormatV2Str, dayStatus } from './../../constants';
import { useMedia } from 'hooks';

import './LowestRatesSlider.css';

const LowestRatesSlider = ({
    lowestRateDays = [],
    lowestRateNextDays = [],
    lowestRateMonthIndexes = [],
    Lang,
    onClick,
    countryCode,
    cellPadding = 15,
    mainClass = 'ab-lowest-rate',
    wrapperClass = '',
    title = 'LOWEST MONTHLY RATE',
    type = 'monthly',
    animation = false,
    height = '55px',
}) => {
    const slidesToShow = useMedia(
        // Media queries
        [
            '(min-width: 850px)',
            '(min-width: 750px)',
            '(min-width: 600px)',
            '(min-width: 350px)',
        ],
        // slides
        [5, 4, 3, 3],
        // Default
        1
    );

    return (
        lowestRateDays?.length > 0 && (
            <div className={`ab-lowest-rates-slider-cnt ${wrapperClass}`}>
                <h2>{title}</h2>
                <Carousel
                    slidesToShow={slidesToShow}
                    slidesToScroll={slidesToShow}
                    defaultControlsConfig={{
                        pagingDotsStyle: { display: 'none' },
                        prevButtonText: <FaChevronLeft />,
                        nextButtonText: <FaChevronRight />,
                        prevButtonClassName: 'ab-lowest-rate-slider-prev-btn',
                        nextButtonClassName: 'ab-lowest-rate-slider-next-btn',
                    }}
                    cellSpacing={cellPadding}
                    framePadding="0 40px"
                >
                    {lowestRateDays.map((lowestRateDay, index) => {
                        const lowestRateNextDay = lowestRateNextDays[index];
                        const monthIndex = lowestRateMonthIndexes[index];

                        const status = lowestRateDay?.status;
                        let statusClass;

                        switch (status) {
                            case dayStatus.AVAILABLE:
                                statusClass =
                                    'iHotelWebAppCalendarSelectableDay ab-day-available';
                                break;
                            case dayStatus.SOLD_OUT:
                                statusClass = 'ab-day-stop-sale';
                                break;
                            case dayStatus.MIN_STAY:
                                statusClass = 'ab-day-min-stay';
                                break;
                            case dayStatus.NOT_AVAILABLE:
                                statusClass = 'ab-day-stop-sale';
                                break;
                            case dayStatus.STOP_SALE:
                                statusClass = 'ab-day-stop-sale';
                                break;
                            case dayStatus.CALL_US:
                                statusClass = 'ab-day-available';
                                break;
                            default:
                                break;
                        }
                        return (
                            <div
                                className={`${mainClass}  ${statusClass} ${
                                    animation ? 'ab-lowest-rate-button' : ''
                                } ${index === 0 ? 'ab-day-selected' : ''}`}
                                key={index}
                                onClick={() =>
                                    onClick(
                                        lowestRateDay,
                                        lowestRateNextDay,
                                        monthIndex
                                    )
                                }
                                data-date={`${lowestRateDay.date}`}
                            >
                                <div className="ab-lowest-rate-date">
                                    {type === 'daily' ? (
                                        <>
                                            {formatDate(
                                                new Date(lowestRateDay?.date),
                                                dateFormatV2Str,
                                                countryCode
                                            )}{' '}
                                        </>
                                    ) : (
                                        <>
                                            {' '}
                                            {formatDate(
                                                new Date(lowestRateDay?.date),
                                                dateFormatStr,
                                                countryCode
                                            )}
                                        </>
                                    )}
                                </div>
                                <div className="ab-lowest-rate-from">
                                    {lowestRateDay?.price ? (
                                        <>
                                            <span className="ab-lowest-rate-from-price">
                                                {lowestRateDay?.price}
                                            </span>
                                            {lowestRateDay?.currency}
                                        </>
                                    ) : (
                                        <div style={{ color: '#ff5140' }}>
                                            {Lang?.soldOut}
                                        </div>
                                    )}
                                </div>
                                {type === 'daily' && (
                                    <>
                                        {lowestRateDay?.status === 'MIN' && (
                                            <div className="lowest-rate-min-label">
                                                <div
                                                    style={{
                                                        color: '#b6723d',
                                                        display: 'inline-block',
                                                        marginRight: '5px',
                                                    }}
                                                >
                                                    Min stay
                                                </div>
                                                <div
                                                    style={{
                                                        display: 'inline-block',
                                                        color: 'black',
                                                    }}
                                                >
                                                    {lowestRateDay?.min_stay}{' '}
                                                    {Lang?.nights}
                                                </div>
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        );
                    })}
                </Carousel>
            </div>
        )
    );
};

LowestRatesSlider.propTypes = {
    Lang: PropTypes.object.isRequired,
    lowestRateDays: PropTypes.array.isRequired,
    lowestRateNextDays: PropTypes.array.isRequired,
    lowestRateMonthIndexes: PropTypes.array.isRequired,
    onClick: PropTypes.func,
    countryCode: PropTypes.string,
    mainClass: PropTypes.string,
    wrapperClass: PropTypes.string,
    title: PropTypes.string,
    type: PropTypes.string,
    height: PropTypes.string,
    cellPadding: PropTypes.number,
    animation: PropTypes.bool,
};

export default LowestRatesSlider;
